import { useStore } from 'components/contexts/geolocation'

const useGeolocation = () => {
  const store = useStore()

  return store
}

export default useGeolocation
